import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import { AppointmentType, Country } from '../../constants'
import { getDeliveryModelFromJourney } from '../getDeliveryModelFromJourney'

interface IsAcfuProgressiveDisclosureEligibleParameters {
  appointmentType?: AppointmentType | string | null
  country?: Country | string | null
  isFlagEnabled?: boolean
  // Required (not optional) so a caller can't silently forget it and reintroduce the bug where
  // rescheduling an existing ACFU appointment got the same 3-day clamp/reason-capture treatment
  // as booking a new one — PX-3649 is scoped to bookings only.
  isRescheduling: boolean
  journey?: string | null
}

// PX-3649: progressive date disclosure + reason capture is scoped to US, Teleaudiology,
// AFTERCARE_FOLLOW_UP, NEW BOOKINGS ONLY — never for TA_LIGHT/TA_ONSITE, never for any other
// appointment type, and never for a reschedule of an existing appointment.
const isAcfuProgressiveDisclosureEligible = ({
  appointmentType,
  country,
  isFlagEnabled,
  isRescheduling,
  journey,
}: IsAcfuProgressiveDisclosureEligibleParameters): boolean =>
  Boolean(
    isFlagEnabled &&
      !isRescheduling &&
      appointmentType === AppointmentType.AFTERCARE_FOLLOW_UP &&
      country === Country.US &&
      getDeliveryModelFromJourney(journey as string) === DeliveryModel.TELEAUDIOLOGY
  )

export { isAcfuProgressiveDisclosureEligible }
